import { useCallback, useEffect, useRef, useState } from 'react'

export const useReviewPreviewSidecar = (closeTransitionMs: number) => {
  const [isReviewPreviewOpen, setIsReviewPreviewOpen] = useState(false)
  const [isReviewPreviewClosing, setIsReviewPreviewClosing] = useState(false)
  const closeTimerRef = useRef<number | undefined>(undefined)

  const clearCloseTimer = useCallback(() => {
    if (closeTimerRef.current === undefined) return

    window.clearTimeout(closeTimerRef.current)
    closeTimerRef.current = undefined
  }, [])

  const resetReviewPreview = useCallback(() => {
    clearCloseTimer()
    setIsReviewPreviewOpen(false)
    setIsReviewPreviewClosing(false)
  }, [clearCloseTimer])

  const openReviewPreview = useCallback(() => {
    clearCloseTimer()
    setIsReviewPreviewClosing(false)
    setIsReviewPreviewOpen(true)
  }, [clearCloseTimer])

  const closeReviewPreview = useCallback(() => {
    clearCloseTimer()
    setIsReviewPreviewOpen(false)
    setIsReviewPreviewClosing(true)

    closeTimerRef.current = window.setTimeout(() => {
      setIsReviewPreviewClosing(false)
      closeTimerRef.current = undefined
    }, closeTransitionMs)
  }, [clearCloseTimer, closeTransitionMs])

  const toggleReviewPreview = useCallback(() => {
    if (isReviewPreviewOpen) {
      closeReviewPreview()
      return
    }

    openReviewPreview()
  }, [closeReviewPreview, isReviewPreviewOpen, openReviewPreview])

  useEffect(() => {
    return () => {
      clearCloseTimer()
    }
  }, [clearCloseTimer])

  return {
    closeReviewPreview,
    isReviewPreviewClosing,
    isReviewPreviewOpen,
    resetReviewPreview,
    toggleReviewPreview,
  }
}
